<template>
  <div>
    <ImpersonationBanner />
    <ClientOnly>
      <HalloweenDecor />
      <ThanksgivingDecor />
    </ClientOnly>

    <div class="app-shell" :class="{ 'app-shell--impersonating': impersonation.active }">
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useImpersonationStore } from '~/store/impersonation';

// Mounted at the root rather than in a layout: valet has several layouts plus pages that opt out of layouts
// entirely (and full-screen editors), and the impersonation warning must be present on every one of them.
const impersonation = useImpersonationStore();
</script>
